import React, { useEffect, useState } from "react";

import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { CRM_ModalAsesor } from "./CRM_ModalAsesor";
import { CRM_LeyendaAuditoria } from "./CRM_LeyendaAuditoria";
import { CRM_LeyendaDepartamento } from "./CRM_LeyendaDepartamento";

// Helper local — genera iniciales de un nombre completo
const getIniciales = (nombre) =>
  (nombre || "").split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]).join("").toUpperCase();

export const CRM_DetalleEquipo = ({ esNuevo, idcliente, asesoresCliente = [], opcionesAsesores = [], opcionesLineas = [], soloLectura, responsableDepartamento = [] }) => {
  const [equipo, setEquipo] = useState(asesoresCliente);
  const [openModal, setOpenModal] = useState(false);

  // El prop llega asíncrono desde GetInfoClienteID — sincroniza al cargar/recargar el cliente
  useEffect(() => {
    setEquipo(asesoresCliente);
  }, [asesoresCliente]);

  const handleAgregarAsesor = () => {
    setOpenModal(true);
  };

  // El POST de guardado regresa el listado actualizado — se refleja directo, sin volver a consultar aparte
  const handleGuardarAsesor = (listadoActualizado) => {
    setEquipo(listadoActualizado || []);
  };
  

  const handleEliminarAsesor = (a) => {
    Swal.fire({
      title: "¿Quitar este asesor?",
      text: "El asesor dejará de estar asignado a este cliente en esta línea.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, quitar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;
      request
        .get(`Clientes/CancelaAsesorCliente?idcliente=${Number(idcliente)}&idvendedor=${a.idvendedor}&idlinea=${a.idlinea}`)
        .then((result) => setEquipo(result || []))
        .catch((error) => Swal.fire("EQUIPO", JSON.stringify(error), "error"));
    });
  };

  return (
    <div id="sec-asesores" className="crm-detalle-card" style={{ scrollMarginTop: 170 }}>
      <div className="crm-detalle-card-header crm-detalle-card-header-actions">
        <div>
          <h3>Asesores asignados</h3>
          <p>Personal interno responsable de la cuenta</p>
        </div>
        {!soloLectura && (
          <div className="crm-detalle-card-header-buttons">
            <button type="button" className="btn-primario-solido" onClick={handleAgregarAsesor}>
              <AddCircleOutlineIcon fontSize="small" /> Agregar asesor
            </button>
          </div>
        )}
      </div>

      {equipo.length === 0 ? (
        <div className="crm-detalle-card-body">
          <p className="crm-sin-info">Este cliente aún no tiene asesores asignados.</p>
        </div>
      ) : (
        <div className="crm-detalle-card-body">
          <div className="crm-detalle-equipo-grid">
            {equipo.map((p, i) => (
              <div key={i} className="crm-detalle-equipo-card">
                {!soloLectura && (
                  <button type="button" className="btn-row-menu equipo-btn-editar" onClick={() => handleEliminarAsesor(p)}>
                    <CloseIcon fontSize="small" />
                  </button>
                )}
                <span className="equipo-avatar">{getIniciales(p.asesor)}</span>
                <span className="equipo-nombre">{p.asesor}</span>
                <span className="equipo-rol">{p.linea}</span>
                <span className="equipo-meta">desde {p.desde}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <CRM_ModalAsesor
        open={openModal}
        onClose={() => setOpenModal(false)}
        idcliente={idcliente}
        onGuardado={handleGuardarAsesor}
        opcionesAsesores={opcionesAsesores}
        opcionesLineas={opcionesLineas}
      />

      <div className="crm-detalle-card-footer">
        <CRM_LeyendaDepartamento responsables={responsableDepartamento} idrel={9} />
        <CRM_LeyendaAuditoria auditoria={equipo[0]} />
      </div>
    </div>
  );
};
